import {useCallback, useState} from "react";
import {
  CONTAINER_STATUS_DISPLAY_STORAGE_KEY,
  type ContainerStatusDisplayOptions,
  readContainerStatusDisplay,
  saveContainerStatusDisplay,
} from "./container-status-display";

/** The container status display options, saved per browser under `storageKey`. */
export const useContainerStatusDisplay = (storageKey = CONTAINER_STATUS_DISPLAY_STORAGE_KEY) => {
  const [display, setDisplay] = useState(() => readContainerStatusDisplay(storageKey));
  const onDisplayChange = useCallback((next: ContainerStatusDisplayOptions) => {
    setDisplay(next);
    saveContainerStatusDisplay(next, storageKey);
  }, [storageKey]);
  return {display, onDisplayChange};
};
